import { useState, useEffect } from "react";
import Navbar from "../layouts/nav";
import { Link, useNavigate } from "react-router-dom";
import Footer from "../layouts/footer";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

export default function Register(){

  const [admin, setAdmin] = useState(false);
  const nav = useNavigate();

  async function register(e){
    e.preventDefault();
    if(newPassword !== newPassword2){
      toast.error("Password Didn't match");
      return;
    }
    const response = await fetch('https://biouniverse-api.vercel.app/register',{
      method: 'POST',
      body: JSON.stringify({newUsername, newPassword, email}),
      headers: {'Content-Type': 'application/json'},})
      
      if(response.status === 200){
        
        toast.success('Registration Successful!');
        setTimeout(() => {
          setNewUsername('');
          setNewPassword('');
          setEmail('');
          setNewPassword2('')
      },100);
      }else{
        toast.error('Username Already Taken!');
      }
  }

  async function login(e){
    e.preventDefault();
    if(admin || username.toLowerCase() === 'vishal'){
      if(username.toLowerCase() !== 'vishal'){
        toast.error('You are not an Admin!');
        return;
      }
      const response = await fetch('https://biouniverse-api.vercel.app/admin_login',{
      method: 'POST',
      body: JSON.stringify({username, password}),
      headers: {'Content-Type': 'application/json'},})
      
      if(response.status === 200){
        toast.success('Login Successful!');
        setTimeout(() => {
          setUsername('');
          setPassword('');
      },100);
      setTimeout(() => nav('/admin'), 1500);
      }else{
        toast.error('Wrong Credentials!');
      }
    }else{
    const response = await fetch('https://biouniverse-api.vercel.app/login',{
      method: 'POST',
      body: JSON.stringify({username, password}),
      headers: {'Content-Type': 'application/json'},})
      
      if(response.status === 200){
        toast.success('Login Successful!');
        setTimeout(() => {
          setUsername('');
          setPassword('');
      },100);
        // setTimeout(() => {
        //   nav('/home');
        // },2000)
      }else{
        toast.error('Wrong Credentials!');
      }
    }
  }

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [newUsername, setNewUsername] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [newPassword2, setNewPassword2] = useState('');
  const [email, setEmail] = useState('');


  useEffect(() => {
		// List of JS files to reload
		const jsFiles = [
    'assets/js/scrolltoTop.js',
		'assets/js/custom.js',
		];
	
		// Create script elements for each JS file
		jsFiles.forEach((filePath) => {
		  const script = document.createElement('script');
		  script.src = filePath;
		  script.async = true;
		  document.body.appendChild(script);
		});
	
		// Clean up the script elements when the component unmounts
		return () => {
		  jsFiles.forEach((filePath) => {
			const script = document.querySelector(`[src="${filePath}"]`);
			if (script) {
			  document.body.removeChild(script);
			}
		  });
		};
	  }, []);
    
    const [color, setClass] = useState('none');
    function change(e)
    {
    let button = e.target.innerHTML;
    const container = document.querySelector(".register_container");
    if(button === 'Sign up'){
        setClass(container.classList.add("register_sign-up-mode"));
    }
    else{
        setClass(container.classList.remove("register_sign-up-mode"));
    }
    }
    return(
        <>

  <Navbar style={'#1A374D'} active={'login'}></Navbar>



        <div className="register_container mt-5">
      <div className="register_forms-container">
        <div className="register_signin-signup">


          <form className="register_sign-in-form" onSubmit={login}>
            <h2 className="register_title">Sign in</h2>
            <div className="register_input-field">
              <i className="fas fa-user"></i>
              <input type="text" placeholder="Username" value={username} onChange={e => setUsername(e.target.value)} required/>
            </div>
            <div className="register_input-field">
              <i className="fas fa-lock"></i>
              <input type="password" placeholder="Password" value={password} onChange={e => setPassword(e.target.value)} required/>
            </div>
            <div className="container p-3" style={{width: '22rem'}}>
              <div className="row">
                <div className="col-sm-12 col-md-6 d-flex justify-content-center"><input type="submit" value="Login" className="register_btn register_solid" onClick={e => setAdmin(false)}/></div>
                <div className="col-sm-12 col-md-6 d-flex justify-content-center"><input type="submit" value="Login as Admin" className="register_btn register_solid" onClick={e => setAdmin(true)}/></div>
              </div>
            </div>
            <p className="register_social-text">Or Sign in with social platforms</p>
            <div className="register_social-media">
              <a href="https://github.com/vishal257" className="register_social-icon">
                <i className="fab fa-github"></i>
              </a>
              <a href="https://twitter.com/Vishal_webengg" className="register_social-icon">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="https://www.instagram.com/vishal.webengg/" className="register_social-icon">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="https://www.linkedin.com/in/vishalweb/" className="register_social-icon">
                <i className="fab fa-linkedin-in"></i>
              </a>
            </div>
          </form>


          <form className="register_sign-up-form" onSubmit={register}>
            <h2 className="register_title">Sign up</h2>
            <div className="register_input-field">
              <i className="fas fa-user"></i>
              <input type="text" placeholder="Username" value={newUsername} onChange={e => setNewUsername(e.target.value)} required/>
            </div>
            <div className="register_input-field">
              <i className="fas fa-envelope"></i>
              <input type="email" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} required/>
            </div>
            <div className="register_input-field">
              <i className="fas fa-lock"></i>
              <input type="password" placeholder="Password" value={newPassword} onChange={e => setNewPassword(e.target.value)} required/>
            </div>
            <div className="register_input-field">
              <i className="fas fa-lock"></i>
              <input type="password" placeholder="Confirm Password" value={newPassword2} onChange={e => setNewPassword2(e.target.value)} required/>
            </div>
            <input type="submit" className="register_btn" value="Sign up" />
            <p className="register_social-text">Or Sign up with social platforms</p>
            <div className="register_social-media">
              <a href="https://www.facebook.com/login/" className="register_social-icon">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="https://twitter.com/i/flow/login?input_flow_data=%7B%22requested_variant%22%3A%22eyJsYW5nIjoiZW4ifQ%3D%3D%22%7D" className="register_social-icon">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="https://accounts.google.com/v3/signin/identifier?hl=en-gb&ifkv=AVQVeyxYF67N4yaM87CD3lK0bnYdFnYs_p_RaBRhePplPF1Yz5Wskb-65H-SdniWQLb6CPZ7s5PN&flowName=GlifWebSignIn&flowEntry=ServiceLogin&dsh=S-1308146844%3A1697458934088901&theme=glif" className="register_social-icon">
                <i className="fab fa-google"></i>
              </a>
              <a href="https://in.linkedin.com/?src=go-pa&trk=sem-ga_campid.14650114788_asid.145595942605_crid.651893406691_kw.linked%20in%20login_d.c_tid.kwd-8081146249_n.g_mt.e_geo.9153767&mcid=6844056167778418689&cid=&gclid=EAIaIQobChMItfGvu8f6gQMVaaNmAh3HngE3EAAYASAAEgJZuvD_BwE&gclsrc=aw.ds" className="register_social-icon">
                <i className="fab fa-linkedin-in"></i>
              </a>
            </div>
          </form>

          
        </div>
      </div>

      <div className="register_panels-container">
        <div className="register_panel register_left-panel">
          <div className="register_content">
            <h3  style={{color: 'white'}}>New here ?</h3>
            <p>
            Ready for a wild ride? Join the BioUniverse adventure and explore Earth's wonders like never before. Let's go!
            </p>
            <button className="register_btn register_transparent" id="register_sign-up-btn" onClick={change}>
              Sign up
            </button>
          </div>
          <img src="assets/RegisterForm/img/pic2.webp" className="register_image" alt="" />
        </div>
        <div className="register_panel register_right-panel">
          <div className="register_content">
            <h3  style={{color: 'white'}}>One of us ?</h3>
            <p>
              Back for more adventures? Sign in and let's continue our BioUniverse journey together. Your discoveries await!
            </p>
            <button className="register_btn register_transparent" id="register_sign-in-btn" onClick={change}>
              Sign in
            </button>
          </div>
          <img src="assets/RegisterForm/img/pic1.webp" className="register_image" alt="" />
        </div>
      </div>
    </div>

    <Footer/>

    <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
    />

        </>
    );
}